import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconPersonFollowing = /*@__PURE__*/ proxyCustomElement(class CosmosIconPersonFollowing extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '981587299b0cd5a5ce2b78ccffe63547587f226f', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '8f1b3d831f261429db83a3452688ad5ade48febf', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'edb96def0b83500656637484ba4bd0067e739d58', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M11.12 3.706a3.84 3.84 0 0 0-2.97-1.26 3.84 3.84 0 0 0-2.97 1.258 3.8 3.8 0 0 0-.828 3.061l.28 2.458c.14 1.882 1.689 3.32 3.518 3.266 1.83.053 3.377-1.383 3.52-3.266l.275-2.437a3.8 3.8 0 0 0-.825-3.08m-.379 9.803a5.62 5.62 0 0 1-5.182 0 .51.51 0 0 0-.424-.034A6.23 6.23 0 0 0 1 19.016a.513.513 0 0 0 .515.54h13.268a.515.515 0 0 0 .515-.54 6.23 6.23 0 0 0-4.133-5.54.51.51 0 0 0-.425.033m9.744-7.352a.54.54 0 0 0-.762 0l-3.782 3.876-1.692-1.444a.54.54 0 0 0-.728.03l-.387.397a.456.456 0 0 0 .024.668l2.433 2.182a.54.54 0 0 0 .738-.023l4.537-4.65a.455.455 0 0 0 0-.645z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-person-following", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-person-following"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-person-following":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconPersonFollowing);
            }
            break;
    } });
}

export { CosmosIconPersonFollowing as C, defineCustomElement as d };
